'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ValidatedFieldDirective=require('../../../../dist-es6/client/directives/validatedFieldDirective/validatedFieldDirective');

const LocalReferenceMidnight=new Date(1970,0,1);
const DefaultTimePickerOptions={
step:15,
timeFormat:'h:i A',
minDate:LocalReferenceMidnight};let


ValidatedTimePickerDirective=function(_ValidatedFieldDirect){_inherits(ValidatedTimePickerDirective,_ValidatedFieldDirect);function ValidatedTimePickerDirective(){_classCallCheck(this,ValidatedTimePickerDirective);return _possibleConstructorReturn(this,_ValidatedFieldDirect.apply(this,arguments))}_createClass(ValidatedTimePickerDirective,[{key:'objectBindings',get:function()
{
return['form','value','submissionResult','customErrorHandler','isDisabled','disabledClassOnly','timePickerOptions'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/validatedTimePickerDirective/validatedTimePickerTemplate';
}},{key:'controller',get:function()

{
return ValidatedTimePickerController;
}}]);return ValidatedTimePickerDirective}(ValidatedFieldDirective);let


ValidatedTimePickerController=function(_ValidatedFieldDirect2){_inherits(ValidatedTimePickerController,_ValidatedFieldDirect2);_createClass(ValidatedTimePickerController,null,[{key:'$inject',get:function()
{
return['$scope','$timeout','$element'];
}}]);

function ValidatedTimePickerController($scope,$timeout,$element){_classCallCheck(this,ValidatedTimePickerController);var _this2=_possibleConstructorReturn(this,
_ValidatedFieldDirect2.call(this,$scope));



if(_.exists(_this2.value)&&_this2.value instanceof Date){
_this2.valueAsDate=new Date(_this2.value);
}else{
_this2.valueAsDate=new Date(LocalReferenceMidnight);
}

_this2._defaultTime=new Date(_this2.valueAsDate);
_this2._defaultErrorMessage='Invalid time.';
_this2.timePickerOptions=_.assign({},_.cloneDeep(DefaultTimePickerOptions),_.cloneDeep(_this2.timePickerOptions));

let resetOnNextUpdate=!1;
$scope.$watch('controller.valueAsDate',function(newValue){
if(!_.exists(newValue)){
resetOnNextUpdate=!0;
}else if(resetOnNextUpdate){
resetOnNextUpdate=!1;
_this2.valueAsDate=_this2._getCorrectedTimeSinceMidnightAsDate(_this2.form[_this2.fieldId].$viewValue);
}else{
_this2.value=_this2.valueAsDate.getTime()-_this2._defaultTime.getTime();
}
});

$element.find('input').bind('blur',function(){

if(_.exists(_this2.valueAsDate)&&_.isDate(_this2.valueAsDate)&&_.isNaN(_this2.valueAsDate.getTime())){
$timeout(function(){
_this2.valueAsDate=_this2._getCorrectedTimeSinceMidnightAsDate($element.find('input')[0].value);
_this2.value=_this2.valueAsDate.getTime()-_this2._defaultTime.getTime();
});
}
});return _this2;
}ValidatedTimePickerController.prototype.

_getCorrectedTimeSinceMidnightAsDate=function _getCorrectedTimeSinceMidnightAsDate(viewValue){
let[viewHours,viewMinutes,viewMeridian]=viewValue.split(/[^APM0-9]/gi);

let hours=parseInt(viewHours,10);
if(viewMeridian==='AM'){
if(hours===12){
hours=0;
}
}else if(hours!==12){
hours+=12;
}

let minutes=parseInt(viewMinutes,10);

return new Date(new Date(this._defaultTime).setHours(hours,minutes,0,0));
};return ValidatedTimePickerController}(ValidatedFieldDirective.controller);


module.exports=ValidatedTimePickerDirective;
//# sourceMappingURL=validatedTimePickerDirective.js.map
